import React from 'react';

import i_close from '../../UI/Close.png';

import i_loading from '../../UI/Cargando.png'
import i_back from '../../UI/back_simple.png';
import svg_loading from '../../UI/oval.svg'

class Transicion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isTransicionPaused: false,
            isTransicionContinued: false,
            videoLoaded: false,
            loadedTransicion: false,
            videoURL: ''
        };

        this.vidRef = React.createRef();
        
    }

    componentDidMount()
    {
        this.setState({
            videoURL: null
        })
        let request = window.indexedDB.open('videos_db', 1);
    
        // onerror handler signifies that the database didn't open successfully
        request.onerror = () => {
            console.log('Database failed to open');
        };
    
        // onsuccess handler signifies that the database opened successfully
        request.onsuccess = () => {
            this.setState(prevstate => ({
                db: request.result
            }),
            () => {
                let objectStore = this.state.db.transaction('videos_os').objectStore('videos_os');
                let req = objectStore.get(this.props.linkTransition);
                
                req.onsuccess = () => 
                {
                    // If the result exists in the database (is not undefined)
                    if(req.result) {
                        // Grab the videos from IDB and display them using displayVideo()
                        //console.log('taking video '+this.props.linkTransition+' from IDB');
                        //this.displayVideo(req.result.mp4, req.result.name);
                        this.setState(prev => ({
                            videoURL: window.URL.createObjectURL(req.result.mp4)
                            //videoLinkA: React.createElement('a', { download: 'filename.mp4', href: window.URL.createObjectURL(req.result.mp4)}, 'download')
                        }),
                        ()=>{
                            //this.forceUpdate();
                            //console.log('videoURL: ',this.state.videoURL)
                        })
                        
                    } else {
                        // Fetch the videos from the network
                        //this.fetchVideoFromNetwork(this.videos[i]);                   
                        this.setState(prev => ({
                            videoURL: this.props.linkTransition
                        }),
                        ()=>{
                            //this.forceUpdate();
                            //console.log('videoURL: ',this.state.videoURL)
                        })
                    }
                };

                req.onerror = function() {
                    console.log('req error: ', req.error);
                }
            }
            )
        }
        //console.log('link trans: ', this.props.linkTransition)
        /*if(prevProps.linkTransition !== this.props.linkTransition)
        {*/
            

        //}
    }
    
    finishTransition  = () =>
    {
        //console.log('finish transition')
        let { handleEndTransicion} = this.props;
       
        this.setState({isTransicionPaused:false});

        handleEndTransicion();
    }

    pauseVideo = () => {
        //this.vidRef.current.pause();
    }

    pauseTransition = (payload) =>
    {
        let {seg} = payload;
        if(this.vidRef.current.currentTime >= seg && !this.state.isTransicionPaused)  //float segundos.ms | > porque es poco probable que sea ==
        {
           // this.vidRef.current.pause();
            //console.log('paraaa');
            this.setState({isTransicionPaused: true})
        }
    }

    continueTransition = () => {
        this.vidRef.current.play();
        this.setState({isTransicionContinued: true})
    }

    handlePlayTransicion = () => {
        if(!this.vidRef.current.paused)
        {
            this.vidRef.current.pause();
        }            
        else
        {
            let playPromise = this.vidRef.current.play();
            if(playPromise !== undefined){
                playPromise.then(_ => {

                }).catch(error => {
                    console.log(error, "error at playback")
                })
            }
        }            
    }

    handleVideoLoaded = ()=> {
        //console.log('cargo el video'); 
        this.setState({videoLoaded: true});
    }

    handleCanStartTransicion = () =>
    {
       //console.log('cargó, muestrese');
       this.setState({loadedTransicion:true});
    }

    componentDidUpdate(prevProps, prevState){
        
    }

    render()
    {
        
        let { linkTransition, handleCanStartTransicion} = this.props;
        let { isTransicionPaused, isTransicionContinued, videoLoaded, loadedTransicion } = this.state;

        //console.log("video link: ", linkTransition);
        return (
            
            <div className={`div-video ${loadedTransicion ? "loaded":""}`}> 
                {
                this.state.videoURL ?     
                <video ref={this.vidRef} className="div-frame" autoPlay muted 
                    style={{
                        pointerEvents: 'none'
                    }}
                    onCanPlayThrough ={ this.handleCanStartTransicion }
                    //onPlay={ () => console.log('empieza la trans')}
                    onClick={this.handlePlayTransicion}
                    onTimeUpdate={ () => this.pauseTransition({seg:10})}
                    onEnded={this.finishTransition
                    }>
                        <source src={this.state.videoURL/*linkTransition*/}  type="video/mp4"/>
                </video>
                :
                <div></div>
                }
                
                {!videoLoaded ?
                <div className="video-canvas-loading"><img className="loader-circle"  src={ svg_loading } /> </div>
                : <div></div> 
                }  
                     
                {isTransicionPaused && !isTransicionContinued ? 
                    <button className="btn-continue" onClick={this.continueTransition}> <img src={i_back} /></button>
                    :<span></span>
                }
                
            </div>
        );
    }
}

export default Transicion;